'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAuthorLink = exports.metadataIdFixer = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var metadataIdFixer = exports.metadataIdFixer = function metadataIdFixer(id) {
  if (!id) {
    throw new Error('metadataIdFixer requires a metadataId');
  }

  // Support Legacy Bib IDs
  if (id.match(/^\d+$/)) {
    return id;
  }

  var _id$split = id.split(/[SC]/g),
      _id$split2 = _slicedToArray(_id$split, 3),
      _blank = _id$split2[0],
      sourceLibId = _id$split2[1],
      bibId = _id$split2[2]; // eslint-disable-line no-unused-vars


  var paddedSourceLibId = _lodash2.default.padStart(sourceLibId, 3, '0');

  return '' + bibId + paddedSourceLibId;
};

var getAuthorLink = exports.getAuthorLink = function getAuthorLink(author) {
  return '/search?q=' + encodeURIComponent(author) + '&search_category=author&t=author';
};

// TODO: get rid of the default export.  named exports only in utils/helper files
exports.default = {
  metadataIdFixer: metadataIdFixer,
  getAuthorLink: getAuthorLink
};


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/utils/link/lib/index.js
// module id = 487
// module chunks = 0 3 4 9 13